/**
 * Casbin domain strings, in the one spelling the gateway builds.
 *
 * The matcher compares a non-wildcard domain byte for byte, so a policy written under
 * any other spelling — upper-cased, padded, `Company:` — matches no request the gateway
 * ever produces. `company_or_system_domain` lower-cases the uuid it parses out of
 * `x-company-id`; this does the same, so a value that arrived from a URL or a paste
 * still lands on the canonical form.
 */

/** Every domain at once. Platform-wide, and never writable from the cabinet. */
export const DOMAIN_ALL = '*';

/** The cross-tenant domain. A company owner holds nothing here — see requestInCompany. */
export const DOMAIN_SYSTEM = 'system';

/** `company:{uuid}` — the domain a cabinet caller is authorized in, and the only one
 *  `domain_must_match_scope` lets them NAME while sending that company's header. */
export const companyDomain = (companyId: string) =>
  `company:${companyId.trim().toLowerCase()}`;
